import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AdminActiveRoutePipe } from '../../../pipes/admin-active-route-pipe';
import { filter, map, Observable, startWith } from 'rxjs';
import { NavigationHelper } from '../../../helpers/navigationHelper';

@Component({
  selector: 'app-admin-sidebar',
  imports: [AdminActiveRoutePipe],
  templateUrl: './admin-sidebar.html',
  styleUrl: 'admin-sidebar.scss',
})
export class AdminSidebar implements OnInit, OnDestroy {

  private router = inject(Router);
  private navigationHelper = inject(NavigationHelper);
  private activatedRoute = inject(ActivatedRoute);
  currentRoute = signal('');
  private url$: Observable<string> | undefined;

  navTo(path: string) {
    this.navigationHelper.navigateTo([`/admin/${path}`]);
  }

  ngOnInit() {
    this.url$ = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      startWith(null),
      map(() => {
        const firstChild = this.activatedRoute.firstChild;
        if (firstChild?.snapshot.url.length && firstChild.snapshot.url.length > 0) {
          return firstChild.snapshot.url[0].path;
        }
        return '';
      })
    );
    
    this.url$.subscribe(url => {
      this.currentRoute.set(url);
    });
  }

  ngOnDestroy() { 
    this.url$?.subscribe().unsubscribe();
  }
}
